/* ============================================================================
   Wishlist nativo (portado de CAT) — integración con Canopy
   ----------------------------------------------------------------------------
   assets/cat-wishlist.js es una copia idéntica del de CAT. Este archivo agrega
   solo lo que Canopy necesita, sin tocar ese núcleo:

   1. Migración: el wishlist anterior guardaba handles en la cookie
      "wishlistList" (__handle1__handle2). Se convierten una sola vez al formato
      de CAT (localStorage "cat:wishlist") para que nadie pierda sus favoritos.
   2. Carrito: cat-wishlist.js avisa con el evento `cart:update` (Horizon) al
      agregar desde el drawer; aquí se refresca el minicart de Canopy.
   3. GA4: los mismos eventos que CAT (add_to_wishlist, remove_from_wishlist,
      view_wishlist, share_wishlist y add_to_cart desde el drawer).
   ============================================================================ */
(function () {
  'use strict';

  if (window.__hpWishlist) return;
  window.__hpWishlist = true;

  var STORAGE_KEY = 'cat:wishlist';
  var LEGACY_COOKIE = 'wishlistList';

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function currency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || undefined;
  }

  function readItems() {
    try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]') || []; } catch (e) { return []; }
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Shopify && typeof window.theme.Shopify.formatMoney === 'function' && window.theme.money_format) {
      return window.theme.Shopify.formatMoney(cents, window.theme.money_format);
    }
    return (Number(cents || 0) / 100).toFixed(2);
  }

  // --- 1. Migración desde la cookie del wishlist anterior -----------------------
  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? match[1] : null;
  }

  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }

  function migrateLegacyWishlist() {
    var raw = readCookie(LEGACY_COOKIE);
    if (!raw) return;

    var handles;
    try { handles = decodeURIComponent(raw).split('__'); } catch (e) { handles = raw.split('__'); }
    handles = handles.filter(Boolean).slice(0, 50);
    if (!handles.length) { deleteCookie(LEGACY_COOKIE); return; }

    Promise.all(handles.map(function (handle) {
      return fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var items = readItems();
      var known = items.map(function (item) { return String(item.id); });

      products.forEach(function (p) {
        if (!p || known.indexOf(String(p.id)) !== -1) return;
        var variants = p.variants || [];
        var variant = variants.filter(function (v) { return v.available; })[0] || variants[0] || {};
        var image = p.featured_image || '';
        if (image.indexOf('//') === 0) image = 'https:' + image;
        if (image) image += (image.indexOf('?') === -1 ? '?' : '&') + 'width=600';
        items.push({
          id: String(p.id),
          variantId: String(variant.id || ''),
          title: String(p.title || ''),
          url: String(p.url || ('/products/' + p.handle)),
          image: image,
          price: formatMoney(p.price)
        });
        known.push(String(p.id));
      });

      try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) { return; }
      deleteCookie(LEGACY_COOKIE);
      window.dispatchEvent(new CustomEvent('cat:wishlist:update', { detail: { items: items } }));
    });
  }

  // --- 2. Agregar al carrito desde el drawer → refrescar el minicart de Canopy --
  document.addEventListener('cart:update', function (e) {
    if (!e.detail || e.detail.sourceId !== 'cat-wishlist') return;
    if (window.theme && typeof window.theme.updateCartSummaries === 'function') {
      window.theme.updateCartSummaries(false, false);
    }
  });

  // --- 3. GA4 (mismos eventos que el datalayer de CAT) --------------------------
  function push(payload, isEcommerce) {
    window.dataLayer = window.dataLayer || [];
    if (isEcommerce) window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  }

  function itemFromToggle(btn) {
    var price = parseFloat(btn.getAttribute('data-product-price-value'));
    return {
      item_id: btn.getAttribute('data-product-id'),
      item_name: btn.getAttribute('data-product-title') || undefined,
      price: isNaN(price) ? undefined : price,
      quantity: 1
    };
  }

  // Fase de captura: se lee el estado ANTES de que cat-wishlist.js lo cambie.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cat-wishlist-toggle]');
    if (toggle) {
      var wasActive = toggle.getAttribute('aria-pressed') === 'true' || toggle.classList.contains('is-active');
      var item = itemFromToggle(toggle);
      setTimeout(function () {
        if (!item.item_id) return;
        push({
          event: wasActive ? 'remove_from_wishlist' : 'add_to_wishlist',
          ecommerce: { currency: currency(), value: item.price, items: [item] }
        }, true);
      }, 0);
      return;
    }

    if (e.target.closest('[data-cat-wishlist-open]')) {
      push({ event: 'view_wishlist', item_count: readItems().length });
      return;
    }

    if (e.target.closest('[data-cat-wishlist-share]')) {
      push({ event: 'share_wishlist', item_count: readItems().length });
      return;
    }

    var addBtn = e.target.closest('[data-cat-wishlist-cart-add]');
    if (addBtn) {
      var variantId = String(addBtn.getAttribute('data-cat-wishlist-cart-add'));
      var stored = readItems().filter(function (i) { return String(i.variantId) === variantId; })[0];
      if (!stored) return;
      push({
        event: 'add_to_cart',
        hp_source: 'wishlist_drawer',
        ecommerce: { currency: currency(), items: [{ item_id: stored.id, item_name: stored.title, quantity: 1 }] }
      }, true);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', migrateLegacyWishlist);
  } else {
    migrateLegacyWishlist();
  }
})();
